import React from 'react';

import BalancePaidReportForm from '../Common/Forms/BalancePaidReportForm';
import CustomOfferDebtorReportForm from '../Common/Forms/CustomOfferDebtorReportForm';
import DepositInstalmentRefundReportForm from '../Common/Forms/DepositInstalmentRefundReportForm';
import ExportCreditsMovementsForm from '../Common/Forms/ExportCreditsMovementsForm';
import ExportCreditsSummaryForm from '../Common/Forms/ExportCreditsSummaryForm';
import ExportFinanceRecReportForm from '../Common/Forms/ExportFinanceRecReportForm';
import ExportItemsPurchasedForm from '../Common/Forms/ExportItemsPurchasedForm';
import ExportItemsPurchasedSummaryForm from '../Common/Forms/ExportItemsPurchasedSummaryForm';
import ExportItemsPurchasedFormV2 from '../Common/Forms/ExportItemsPurchasedV2Form';
import ExportItemsRefundedV2Form from '../Common/Forms/ExportItemsRefundedV2Form';
import ExportPromoCodeSpendForm from '../Common/Forms/ExportPromoCodeSpendForm';
import ExportRefundsForm from '../Common/Forms/ExportRefundsForm';
import ExportStripeBalanceTransactionsForm from '../Common/Forms/ExportStripeBalanceTransactionsForm';
import ExportTransactionsForm from '../Common/Forms/ExportTransactionsForm';
import ExportTravelVouchersSoldReportForm from '../Common/Forms/ExportTravelVouchersSoldReportForm';
import ExportXeroTrialBalanceForm from '../Common/Forms/ExportXeroTrialBalanceForm';
import ExportXeroTrialBalanceSyncForm from '../Common/Forms/ExportXeroTrialBalanceSyncForm';
import GrossDepositReportForm from '../Common/Forms/GrossDepositReportForm';
import OutstandingDepositBalanceReportForm from '../Common/Forms/OutstandingDepositBalanceReportForm';
import ExportLebtCreditForm from '../Common/Forms/businessTraveller/ExportLebtCreditForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_REPORT = 'credit-summary';

const reports = [
  {
    title: 'Transaction Report',
    slug: 'transactions',
    component: ExportTransactionsForm,
  },
  {
    title: 'Items Purchased report',
    slug: 'items-purchased',
    component: ExportItemsPurchasedForm,
  },
  {
    title: 'Items Purchased report V2',
    slug: 'items-purchased-v2',
    component: ExportItemsPurchasedFormV2,
  },
  {
    title: 'Items Purchased Summary report',
    slug: 'items-purchased-summary',
    component: ExportItemsPurchasedSummaryForm,
  },
  {
    title: 'Items Refund report',
    slug: 'items-refunded',
    component: ExportRefundsForm,
  },
  {
    title: 'Items Refunded report V2',
    slug: 'items-refunded-v2',
    component: ExportItemsRefundedV2Form,
  },
  {
    title: 'Credit movements',
    slug: 'credit-movements',
    component: ExportCreditsMovementsForm,
  },
  {
    title: 'Credit summary report',
    slug: 'credit-summary',
    component: ExportCreditsSummaryForm,
  },
  {
    title: 'LEBT Credit report',
    slug: 'lebt-credit',
    component: ExportLebtCreditForm,
  },
  {
    title: 'Promo Code Spend report',
    slug: 'promo-codes-spend',
    component: ExportPromoCodeSpendForm,
  },
  {
    title: 'Travel Vouchers Sold',
    slug: 'travel-vouchers-sold',
    component: ExportTravelVouchersSoldReportForm,
  },
  {
    title: 'Finance Reconciliation Report',
    slug: 'finance-reconciliation',
    component: ExportFinanceRecReportForm,
  },
  {
    title: 'Stripe Balance Transactions Report',
    slug: 'stripe-balance-transactions',
    component: ExportStripeBalanceTransactionsForm,
  },
  {
    title: 'Xero Trial Balance - Sync',
    slug: 'xero-trial-balance-sync',
    component: ExportXeroTrialBalanceSyncForm,
    sortKey: 'Xero Trial Balance - 1 Sync',
  },
  {
    title: 'Xero Trial Balance - Export',
    slug: 'xero-trial-balance',
    component: ExportXeroTrialBalanceForm,
    sortKey: 'Xero Trial Balance - 2 Export',
  },
  {
    title: 'Outstanding Deposit Balance Report',
    slug: 'outstanding-deposit-balance',
    component: OutstandingDepositBalanceReportForm,
  },
  {
    title: 'Custom Offer Debtor Report',
    slug: 'custom-offer-debtor',
    component: CustomOfferDebtorReportForm,
  },
  {
    title: 'Gross Deposits And Instalments Report',
    slug: 'gross-deposits',
    component: GrossDepositReportForm,
  },
  {
    title: 'Balance Paid Report',
    slug: 'balance-paid',
    component: BalancePaidReportForm,
  },
  {
    title: 'Deposits and Instalments Refund Report',
    slug: 'deposit-instalments-refunds',
    component: DepositInstalmentRefundReportForm,
  },
];

export default function MonthReportsPage() {
  return <ContentWithSidebar items={reports} defaultItem={DEFAULT_REPORT} />;
}
